import SETTINGS from './settings';

const init = (config, images = {}) => {
  Object.keys(SETTINGS).forEach(key => {
    if (config[key]) {
      SETTINGS[key] = config[key];
    }
  });

  // EXTRACT ALT TEXTS - KEY: ALT
  SETTINGS.CLOUDINARY_ALT_TEXTS = Object.values(images).reduce((acc, items) => {
    items.forEach(image => {
      acc[image.key] = image.alt;
    });

    return acc;
  }, {});
};

export default init;
